import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AppContext } from './AppContext';
import { ROUTES } from './common/constants';
import { AppContextType } from './types/appContext.type';

function PublicRoute() {
  const {
    getToken,
    state: { currentUser },
  } = useContext(AppContext) as AppContextType;
  const idToken = getToken();

  return idToken && currentUser?.firstName ? (
    <Navigate to={ROUTES.MAIN} />
  ) : (
    <Outlet />
  );
}

export default PublicRoute;
